import { cn } from '../utils/cn';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-[3px]',
};

/**
 * Animated circular loading indicator.
 * For full-page loading use size="lg" with a centering wrapper.
 */
const LoadingSpinner = ({ size = 'md', className }: LoadingSpinnerProps) => (
  <div
    role="status"
    aria-label="Loading"
    className={cn(
      'animate-spin rounded-full border-border-strong border-t-brand',
      sizeClasses[size],
      className,
    )}
  />
);

export default LoadingSpinner;
